import { InfoTip } from "@/components/app/Common";
import { INDEX_ORDER } from "@/lib/assessments";

function Bar({ k, d, ideal }) {
  return (
    <div className="space-y-1" data-testid={`index-${k}`}>
      <div className="flex items-center justify-between text-sm">
        <span className="flex items-center gap-1.5 text-ink">{d.label} <InfoTip text={`Built from: ${d.built_from}. Shaded area shows the likely range (± standard error).`} testId={`index-info-${k}`} /></span>
        <span className="font-display font-semibold tabular-nums" data-testid={`index-value-${k}`}>{d.value}</span>
      </div>
      <div className="relative h-3 rounded-full bg-[#EFEBE3]">
        {ideal && <div className="absolute inset-y-[-3px] rounded border border-dashed border-[#9A6700] bg-[#F3EEE3]" style={{ left: `${ideal.min}%`, width: `${ideal.max - ideal.min}%` }} title={`Ideal ${ideal.min}–${ideal.max}`} data-testid={`index-ideal-${k}`} />}
        <div className="absolute inset-y-0 rounded-full bg-brand/20" style={{ left: `${d.band[0]}%`, width: `${d.band[1] - d.band[0]}%` }} data-testid={`index-band-${k}`} />
        <div className="absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-brand shadow" style={{ left: `${d.value}%` }} />
      </div>
    </div>
  );
}

export function WorkStyleBars({ indices, ideal }) {
  return (
    <section className="panel space-y-4 p-5" data-testid="work-style-bars">
      <div>
        <h3 className="text-base font-semibold">Work-style indices</h3>
        <p className="text-xs text-ink-muted">0–100. Dot = score, teal shading = likely range, dashed box = the job's ideal range.</p>
      </div>
      {INDEX_ORDER.filter((k) => indices[k]).map((k) => <Bar key={k} k={k} d={indices[k]} ideal={ideal[k]} />)}
      <p className="text-xs text-ink-muted">Confrontational Tendency describes how readily someone pushes back in disagreements — higher isn't better or worse on its own.</p>
    </section>
  );
}
